import type { GetStaticPaths, GetStaticPropsContext } from 'next'

import { DrillTopicOverview } from '~/types/theory'
import DrillTopic from '~/drill/pages/DrillTopic.page'
import { AppLanguage } from '~/types/locale'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { getTopicData } from '~/../utils/data-fetch/theory/theory.query'

import { getMultipleChoiceTests, getRunningQueriesThunk } from '~/redux/apis/multiple-choice-test-api'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

export default function DrillTopicWrapper({ topic }: { topic: DrillTopicOverview }): React.ReactElement {
  return <DrillTopic topic={topic} />
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getProps: GetProps =
  (store) =>
  async ({ locale, params }: GetStaticPropsContext<{ topicId: string }>) => {
    const { topicId } = params || {}
    if (!topicId) {
      return {
        notFound: true,
      }
    }

    const drillPaths = ['drill', topicId]
    const topicData = await getTopicData({
      paths: drillPaths,
      language: locale as AppLanguage,
    })

    if (!topicData) {
      return { notFound: true }
    } else if ('destinationPath' in topicData) {
      return {
        redirect: {
          destination: topicData.destinationPath,
          statusCode: 308,
        },
      }
    }

    const { encyclopediaTopic } = topicData

    store.dispatch(
      getMultipleChoiceTests.initiate({
        drillUrl: encyclopediaTopic.path,
      }),
    )

    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    return {
      props: {
        path: `/drill/${topicId}`,
        topic: encyclopediaTopic,
        namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'drill'],
      },
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)
